var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/contactus/solid/icon-email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2680852,15.937121 L26.4076587,22.6578359 C26.1727651,22.8570061 25.9021269,23 25.6570205,23 L4.32255495,23 C4.08255498,23 3.80681033,22.8570061 3.57191674,22.6578359 L11.7063839,15.9473348 C12.8195752,16.5346313 13.63149,16.9585062 13.7591496,17.0248963 C14.2136176,17.2649218 14.5302133,17.2904564 14.9693622,17.2904564 C15.4085111,17.2904564 15.7251068,17.2598149 16.1795748,17.0248963 L18.2680852,15.937121 Z M27.000001,11.9435046 L27.000001,19.8285988 L20.7293615,14.6501756 L26.4842544,11.6524098 C27.0051055,11.3817427 27.000001,11.6983722 27.000001,11.9435046 Z M3.00098748,11.8432001 C3.00798985,11.6243785 3.06434233,11.4178317 3.51574654,11.6524098 C3.84552,11.823739 5.85635068,12.8752025 8.01178843,14.0053508 L9.01127909,14.5296265 L9.2604267,14.6603894 L3.00000096,19.8285988 Z M26.2544672,7 C27.4493607,7 26.8365948,8.36354931 26.1829779,8.71592723 L16.1846812,14.0884137 C15.84766,14.2671561 15.4136175,14.3539738 14.9744686,14.3539738 C14.5353197,14.3539738 14.1012772,14.2671561 13.764256,14.0884137 L3.76595927,8.71592723 C3.11234233,8.36354931 2.49957644,7 3.69446992,7 L26.2544672,7 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-12.5%",
    width: "133.3%",
    height: "150.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/contactus/solid/icon-email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ee0a2b62242775795814bc5a68af8d06.svg";
export { ForwardRef as ReactComponent };